module.exports = __webpack_public_path__ + "static/changeDetection-6a5c7d86e43ee2255efcee0cce8bfbd4.gif";